// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"76":"TradeItemsView","143":"VatAccountingGroup","457":"Views__TradeItemManagement","779":"Views__VatAccountingGroupManagement"}[chunkId] || chunkId) + "." + {"76":"7b41d3f4","143":"b0f029a0","457":"bd62428e","779":"33b1191e","803":"99d80cc8"}[chunkId] + ".chunk.js";
};